import React, { FC } from 'react';

import { VbzButton } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';

interface SuccessProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: any;
  nextTier?: string;
}

const ModalUpgradeBody: FC<SuccessProps> = ({ onClick, nextTier }) => (
  <ModalBody>
    <div className="smls-modal-header">{nextTier && <h4>Boas-vindas à categoria {nextTier}</h4>}</div>

    <p>
      Sua empresa juntou o valor de passagens aéreas necessário para subir de categoria e agora faz parte da categoria{' '}
      {nextTier}.
      <br />
      <br />
      Confira e aproveite os novos benefícios.
    </p>

    <VbzButton id="submit" className="vbz-update-modal-btn" text="Acessar benefícios" onClick={onClick} />
  </ModalBody>
);

ModalUpgradeBody.defaultProps = {
  nextTier: undefined,
};

export default ModalUpgradeBody;
